export default (value: string) => {
    if (!value) {
        return '-';
    }
    value = value.replace(/\(/g, '').replace(/\)/g, '');
    return `${value.substring(0, value.length - 1)}(${value.substring(value.length - 1, value.length)})`;
}